module.exports = __webpack_public_path__ + "static/media/web-construction.ddedd4c0.svg";